import { render, staticRenderFns } from "./Qrcode.vue?vue&type=template&id=28f4aed4"
import script from "./Qrcode.vue?vue&type=script&lang=js"
export * from "./Qrcode.vue?vue&type=script&lang=js"
import style0 from "./Qrcode.vue?vue&type=style&index=0&id=28f4aed4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports